import { render } from "./MyInscriptions.vue?vue&type=template&id=59164df5&scoped=true"
import script from "./MyInscriptions.vue?vue&type=script&lang=js"
export * from "./MyInscriptions.vue?vue&type=script&lang=js"

import "./MyInscriptions.vue?vue&type=style&index=0&id=59164df5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59164df5"]])

export default __exports__